import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApplicationRoutes } from '../../common/routes';
import { CustomerVoiceRouterService } from '../../core/cv-router.service';

@Component({
  selector: 'app-no-preferred-sites',
  templateUrl: './no-preferred-sites-dialog.component.html',
  styleUrls: ['./no-preferred-sites-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoPreferredSitesDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NoPreferredSitesDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      messageType: string;
    },
    private customerVoiceRouter: CustomerVoiceRouterService,
    public dialog: MatDialog,
  ) {}

  public openDialog(): void {
    this.dialog.open(NoPreferredSitesDialogComponent);
  }

  public goToPreferredSites(): void {
    this.dialogRef.close();
    this.customerVoiceRouter.navigateByUrl(ApplicationRoutes.settings);
  }

  public goToCustomers(): void {
    this.dialogRef.close();
    this.customerVoiceRouter.navigateByUrl(ApplicationRoutes.customers);
  }
}
